<template>
  <div class="page-content about">
    <TopBar :type="1" :logo="logo" />
    <div class="module no1">
      <div class="module-content">
        <div class="module-title">学院介绍</div>
        <div class="module-text">
            <div class="img-1">
              <img src="@/assets/huanghe/img-1.png" alt="">
            </div>
            <p class="college-content" :class="{'active': activeShow === true}">
              培训中心于2003年12月成立，作为黄河公司人力资源管理职能的加强和延伸，主要负责系统内干部职工教育培训、人才交流服务、30名专业师管理及离退休人员服务管理工作及赛务工作，培训中心设置有综合部、技能培训部、理论培训部及离退休办公室四个部室，现有专职在岗干部职工24人，2023年电力生产行业生产技术专业、管理类兼职内训师516人。培训中心2008年3月批准成立中电投水力发电国家职业技能鉴定站，于2022年7月经中国电力企业联合会批准为青海黄河上游水电开发有限责任公司电力行业职业技能等级认定分支机构和电力行业职业能力评价基地，同年12月在中国电力企业联合会首次星级评级机构评选中荣获电力行业人才评价“四星级”基地的称号。2017年11月批准成立中共国家电投党校黄河公司分校。2023年3月，培训中心由青海省总工会批准成立黄河工匠学院。学院在黄河公司领导下，以习近平新时代中国特色社会主义思想为指导，深入学习贯彻党的二十大精神，认真落实中央、青海省、集团公司关于新时代产业工人队伍建设的系列部署要求，准确把握新发展阶段、全面贯彻新发展理念、主动融入新发展格局，坚持以高质量发展为主题，以改革创新为动力，深入推进“黄河工匠学院”建设，加大职业技能培训力度，2023年度高质量完成各类培训班103期，共计培训 15005 人次，总课时2853 课时，在黄河工匠学院协办的首届全国光伏技能大赛完成七期赛前培训工作，共培训了 210 人次，总课时为 832 课时。同时，黄河工匠学院还承办了国家级、省级、集团公司级及公司系统内各类竞赛项目近30期，在不断提升职业技能培育质量，完善技能人才培养体系，培养更多高素质技术技能人才、大国工匠、能工巧匠，打造高原匠心第一院成效初显。
            </p>
            <div class="college-content-but" @click="activeShow = !activeShow">
            <img src="@/assets/huanghe/open-icon.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="module no2" style="border: 0;">
      <div class="module-content">
        <div class="module-title">基地介绍</div>
        <div class="module-text">
          <p class="college-content">
            黄河工匠学院依托国家电投集团黄河上游水电开发有限责任公司培训服务中心建设，在各类培训班组织开展、技能大赛主办承办、成果展示推广、师资课程体系建设、工匠人才培养、管理制度保障等方面具备扎实的基础。聚焦特色优势产业和新兴产业，促进产业聚集、人才聚集和资源聚集，推动创新型、应用型、技能型人才培养，实现职业技能培训高质量发展，聚集规模宏大、质量过硬、结构合理的高水平黄河工匠人才队伍，计划建设工匠学院线上平台及光、风、水、火、冶金实训基地：
          </p>
          <p class="college-title">一、黄河工匠学院光伏、风电实训基地建设</p>
          <p class="college-sub-title">（1）建设目标：</p>
          <p class="college-content">
            结合公司新能源产业发展和对技术人才需求不断增长的现状，按照“科学规划、合理布局、精心建设、产教结合、高标准投入”原则，充分发挥公司新能源产业优势、技术优势，利用现有教培资源，高质量建设新能源实训基地。通过建设集光伏风电仿真系统、实训实操平台、技术交流、技能竞赛四位一体的特色新能源人才培养基地，建立国内一流企业人才培训管理运作模式，打造具有一定行业影响力的新能源人才培训交流平台、技能竞赛平台，助力培养与公司一流清洁能源产业发展相匹配的一流人才队伍。
          </p>
          <p class="college-sub-title">（2）光伏+风电实训基地建设内容：</p>
          <p class="college-content">
            海南州光伏产业园水光互补电站集控室北侧、百兆瓦光伏实证基地红线范围内,利用原规划建设实验楼的建设用地（占地面积4000㎡，使用年限25年，已办理永久征地手续,产权属于光伏产业技术分公司），建设实训大楼，主要包括教学、实训、竞赛三大区域，对应理论培训、仿真培训、实操培训、技能鉴定、技能竞赛五大功能。其中教学区设置了约128㎡的仿真实训教室、4间培训室、1间阶梯教室、3间会议室、4间考评室；实训区室内部分设置1个风电实训平台、1个电气设备实训平台、1个技能实操平台；实训区室外部分设置了光伏风电实战实训平台、登高实训平台、安全实训平台等；竞赛区则需搭建适于50支队伍同时竞赛的比赛用场馆，并设置候赛区、隔离区、裁判休息区、志愿服务区等功能区，占地面积约700平方米。
          </p>
          <div class="college-img">
            <div>
              <img src="@/assets/huanghe/img-2.png" alt="">
              <p class="college-content">光伏+风电实训基地仿真教室</p>
            </div>
            <div>
              <img src="@/assets/huanghe/img-3.png" alt="">
              <p class="college-content">光伏+风电实训基地登高实训平台</p>
            </div>
          </div>
          <p class="college-title">二、黄河工匠学院水电实训基地建设</p>
          <p class="college-sub-title">（1）建设目标：</p>
          <p class="college-content">
            建设集水电技术技能培训、安全实训为一体的特色水电人才培养基地。开发一套水电机组运行、检修、维护标准培训课程体系，培养一批技术精湛、技能高超、经验丰富的水电运行、检修、维护人才，形成一个一流实训基地管理运营方案，能够为公司水电产业持续输送高素质人才队伍。
          </p>
          <p class="college-sub-title">（2）水电实训基地建设内容：</p>
          <p class="college-content">
            黄河公司安全实训基地于2020年建成投运，占地2000㎡。实训基地采用视、听、实操相结合的三维立体式安全培训模式，包含安全用品体验区、通用型实训体验区、专业性实训体验区演播大厅、智慧教室。实训基地投运后，已组织举办22期安全生产实训培训班，参加培训846人次。现安全实训基地有培训教室1间，可容纳70人，一楼预留4间教室，每间可容纳40人。安全实训基地楼北侧建有室外小型足球场。办公楼北侧小广场空地设有室外排球和篮球场地及室外健身器材。生活区内建有一座职工活动中心，面积约1900平方米，室内设有两个羽毛球场地、一个半副篮球场地、三个乒乓球桌案，并配置有一套运动健身器材，办公楼内建有职工书屋和台球室。而此次建设要在原有的培训基地基础上进行优化改造，改造后的培训条件：拥有70人多功能教室1间，40人教室8间，20人会议室5间；能够容纳166人单人住宿和用餐。可同时组织开展起重、钳工、焊接、机械检修、电气检修、低压电工、继电保护、自控、运行、电测仪表等专业技能共72人实操培训和技能鉴定。最大可同时承接3个40人培训班和1个70人培训班，共190人培训。
          </p>
          <div class="college-img-1">
            <img src="@/assets/huanghe/img-4.png" alt="">
            <p class="college-content">光伏+风电实训基地仿真教室</p>
          </div>
          <p class="college-title">三、黄河工匠学院火电实训基地建设方案</p>
          <p class="college-sub-title">（1）建设目标：</p>
          <p class="college-content">
            建设集火电理论学习、仿真培训、技术交流、技能鉴定（竞赛）、资格准入（取证上岗）多位一体的特色火电人才培养基地，建立一流火电人才培训管理运作模式。充分发挥培训和考核两类核心功能，打造具有一定行业影响力的火电人才培训交流平台、技能鉴定中心和火电技能竞赛平台，助力培养与公司火电产业发展相匹配的一流人才队伍。
          </p>
          <p class="college-sub-title">（2）火电实训基地建设内容：</p>
          <p class="college-content">
            根据西宁发电分公司现有场地、培训能力和预期建设目标，拟设置教学、实训、竞赛（技能鉴定、取证资格准入）三大区域，辅以火电安全文化教育宣传区（办公区、厂区安全标语、警示牌及展板等）、火电劳动保护用品及装备展示区（拟选厂区合适位置增设）、火电消防及应急救援体验区（拟结合生产区域增设）。
          </p>
        </div>
      </div>
    </div>
    <div class="deep_cont_box">
      <div class="cont_info">
        <div>
          <img src="@/assets/m/newIndex/phone_icon.png" alt="">
          <div class="text flex">
            <p>热线电话：</p><span>400-0123-823</span>
          </div>
        </div>
        <div class="text">
          <p> 技术支持：中工科创</p>
        </div>
      </div>
      <div class="code_text">
          Copyright © 2015-{{new Date().getFullYear()}} kskstudy.com All Rights Reserved 京ICP备16012224号-3
      </div>
    </div>
  </div>
</template>
<script>
import TopBar from "@/m/common/topBar.vue";
export default {
  name: 'About',
  components: {
    TopBar
  },
  data () {
    return {
      activeShow: false,
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
.page-content {
  background: #FFFFFF;
}
.banner{
  width: 100%;
  margin-bottom: 60px;
}
.module{
  border-bottom: 15px solid #FAFAFB;
  &.no1{
    padding-bottom: 40px;
    .img-1 {
      width: 694px;
      height: 300px;
      margin-bottom: 24px;
      background: #D8D8D8;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .college-content {
      padding: 15px 13px;
      margin: 0 auto;
      background: #FFFFFF;
      height: 350px;
      overflow: hidden;
      margin-bottom: 10px;
    }
    .college-content-but {
      width: 356px;
      margin: 0 auto;
      height: 54px;
      background: #E6EEFF;
      border-radius: 34px;
      padding-top: 20px;
      margin-top: 24px;
      cursor: pointer;
      img {
        display: block;
        width: 32px;
        height: 20px;
        margin: 8px auto;
      }
    }
    .active {
      height: 1580px;
    }
  }
  &.no2{
    .college-title {
      font-family: PingFang SC, PingFang SC;
      font-weight: bold;
      font-size: 28px;
      color: #333333;
      line-height: 40px;
      text-align: left;
      margin-top: 24px;
    }
    .college-sub-title {
      font-weight: bold;
      font-size: 28px;
      color: #333333;
      line-height: 40px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-top: 16px;
      margin-bottom: 16px;
    }
    .college-img {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      img {
        width: 694px;
        height: 396px;
        margin-top: 30px;
      }
      p {
        text-align: center;
        font-weight: 500;
        font-size: 26px;
        color: #666666;
        line-height: 36px;
        margin-top: 16px;
      }
    }
    .college-img-1 {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 30px;
      img {
        width: 694px;
        height: 274px;
      }
      p {
        text-align: center;
        font-weight: 500;
        font-size: 18px;
        color: #666666;
        line-height: 32px;
        margin-top: 16px;
      }
    }
  }
}
.module-content{
  margin: 0 28px;
}
.module-title{
  width: 100%;
  padding: 20px 0;
  padding-left: 12px;
  font-family: 'PingFang SC-Bold';
  font-weight: bold;
  font-size: 30px;
  color: #2973F0;
  line-height: 42px;
  text-align: left;
  position: relative;
  &::after{
    content: '';
    width: 3px;
    height: 24px;
    background-color: #2973F0;
    position: absolute;
    left: 0;
    top: 30px;
    bottom: 16px;
  }
}
.college-content{
  font-weight: 500;
  font-size: 28px;
  color: #333333;
  line-height: 50px;
}
.deep_cont_box{
  width: 100%;
  height: 212px;
  background: #292F36;
  box-sizing: border-box;
  padding: 48px 40px 0;
  margin-top: 150px;
  .cont_info{
    display: flex;
    justify-content: space-between;
    >div{
      display: flex;
      justify-content: space-between;
      font-size: 28px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
      img{
        width: 40px;
        height: 40px;
      }
      span{
        color: #1E84FF;
        opacity: 1;
      }
    }
    .text{
      p{
        opacity: .5;
      }
    }
  }
  .code_text{
    font-size: 24px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 28px;
    text-align: center;
    margin-top: 28px;
    opacity: .5;
    line-height: 40px;
  }
}
</style>
    